import { Action } from 'redux';
import { ACTION_CREATOR_NAME } from 'helpers';
import { PaymentActionTypes } from '../payment.types';

export interface RemoveCardPaymentErrorMessageAction extends Action<PaymentActionTypes.REMOVE_CARD_PAYMENT_ERROR_MESSAGE> {
}

export const removeCardPaymentErrorMessage: () => RemoveCardPaymentErrorMessageAction = () => ({
    type: PaymentActionTypes.REMOVE_CARD_PAYMENT_ERROR_MESSAGE
});
removeCardPaymentErrorMessage[ACTION_CREATOR_NAME] = 'removeCardPaymentErrorMessage';

export type RemoveCardPaymentErrorMessageFunc = (...args: Parameters<typeof removeCardPaymentErrorMessage>) => void;
